<script>
import BaseFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';
import { DevicesService } from '@/services/devices.service';

export default {
  name: 'SerialNumbersFilter',

  extends: BaseFilter,

  data() {
    return {
      name: 'serial_number'
    };
  },

  methods: {
    getData() {
      return DevicesService.getFilteredSerialNumbers({ search: this.search })
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
